'use client';

import useAuthGuard from '@/hooks/auth/useAuthGuard'; // Import the custom hook
import MobileMenu from '../shared/MobileMenu';
import SlidingModal from '../home/mobile/SlidingModal';
import { StytchFactorOtp } from './stytchFactorOtp';
import OnboardingLayout from '../home/mobile/Onboarding/OnboardingLayout';
import ReferralCodeInput from './ReferralCodeInput';
import { useSession } from '@/contexts/LitSessionProvider';
import ProfileForm from '../userSettings/ProfileForm';
import NewUserDeposit from '../deposit/NewUserDeposit';
import SwapLoader from '../trade/SwapLoader';
import ErrorScreen from '../errors/ErrorScreen';
import MobileTopNav from '../shared/TopNav/MobileTopNav';
import { useLocalStorage } from 'usehooks-ts';
import { useRouter } from 'next/router';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import useOnlineStatus from '@rehooks/online-status';
import OfflineErrorScreen from '../errors/OfflineErrorScreen';
import { useEffect, useState } from 'react';
export default function FullScreenGuard({
  children,
  TwoFa = true,
  isSettings = false
}) {
  const isMobile = useIsMobile();
  const {
    showAuthLoader,
    shouldOnboard,
    showReferralInput,
    showTwoFaModal,
    showDeposit,
    runAuthFlow,
    setMFAInfo,
    MFAInfo,
    handleUseReferralCode,
    referralUrlCode,
    clearLitSession,
    hasUsername,
    cloudData,
    progressBar,
    mfaLoading,
    showBalancesLoader
  } = useAuthGuard(TwoFa);
  const {
    PKP,
    decryptedWallets,
    clients
  } = useSession();
  const onlineStatus = useOnlineStatus();
  const [disableRef, setDisableRef] = useLocalStorage(`disableRef-${PKP?.ethAddress}`, false);
  const [isClient, setIsClient] = useState(false);
  const router = useRouter();
  const onPortfolioPage = router.pathname?.includes('portfolio');
  const onFeedPage = router.pathname?.includes('feed');
  const onTradePage = router.pathname?.includes('trade');
  const deletePage = router.pathname?.includes('delete');
  useEffect(() => {
    setIsClient(true);
  }, []);
  if (!isMobile) return;
  if (!onlineStatus) {
    return <>
        <OfflineErrorScreen />;
        <MobileMenu />
      </>;
  }
  if (!PKP && clients?.clientCreationError) {
    return <>
        {' '}
        <ErrorScreen />
      </>;
  }

  // console.log(
  //   'authloaderzz',
  //   showAuthLoader,
  //   'mfaLoading',
  //   mfaLoading,
  //   'showBalancesLoader',
  //   showBalancesLoader
  // );

  if (!isClient) {
    return;
  }
  if (showAuthLoader || mfaLoading || showBalancesLoader && onPortfolioPage) {
    if (PKP?.ethAddress && decryptedWallets?.length && !mfaLoading) {
      if (onPortfolioPage || onFeedPage || onTradePage) {
        return <>
            <SwapLoader isSwap={true} omitText={true} />
            <MobileMenu />
          </>;
      }
      return;
    } else {
      return <>
          <SwapLoader />
          {progressBar ? <div className='fixed bottom-[12%] left-0 w-full flex  justify-center items-center'>
              <div className='w-1/2 rounded-full  mx-auto h-1 bg-genius-cream/50'>
                <div className='h-1 bg-genius-pink rounded-full ' style={{
              width: `${progressBar}%`
            }}></div>
              </div>
            </div> : <> </>}
          <MobileMenu />
        </>;
    }
  }
  if (shouldOnboard) {
    return <div className='min-h-screen'>
        <OnboardingLayout runAuthFlow={runAuthFlow} />
      </div>;
  }
  if (showReferralInput && !disableRef) {
    return <>
        <ReferralCodeInput handleUseReferralCode={handleUseReferralCode} referralUrlCode={referralUrlCode} clearLitSession={clearLitSession} />
        <MobileMenu />
      </>;
  }
  if (!hasUsername) {
    return <>
        <div className='mb-8'>
          <ProfileForm userInfo={cloudData} />
        </div>
        <MobileMenu />
      </>;
  }
  const MFAIsEmail = MFAInfo?.presentMFAInfo?.authMethodType == 10;
  const MFAIsSMS = MFAInfo?.presentMFAInfo?.authMethodType == 11;
  if (showTwoFaModal) {
    return <SlidingModal heightFit={true} isOpen={true} onClose={() => null}>
        <div className='my-4 text-sm px-6 text-genius-cream/50'>
          {' '}
          You have Two Factor Authentication enabled via{' '}
          {MFAIsEmail ? 'email' : MFAIsSMS ? 'SMS' : 'Whatsapp'} . Please{' '}
          {MFAIsEmail ? 'check the email address' : 'check the phone number'} you used to enable Two
          Factor Auth to receive a code.
        </div>

        <StytchFactorOtp authMethodType={MFAInfo?.presentMFAInfo?.authMethodType} askingAuthId={MFAInfo?.presentMFAInfo?.authId} askingProviderValue={MFAInfo?.presentMFAInfo?.providerValue} disableInput={true} skipFinalConfirmationScreen={true} callBack={async (authMethod, providerValue) => {
        setMFAInfo(prev => ({
          ...prev,
          authMethod,
          providerValue
        }));
        return {
          success: true
        };
      }} />
      </SlidingModal>;
  }
  if (showDeposit && !onFeedPage && !deletePage) {
    if (showBalancesLoader) {
      return <>
          <SwapLoader />;
          <MobileMenu />
        </>;
    }
    return <div>
        <MobileTopNav />
        <NewUserDeposit />
        <MobileMenu />
      </div>;
  }
  return children;
}